import { handleActions } from "redux-actions";
import { RECEIVE_COLOUR_ENRICHMENT } from "../constants";
import { receiveColourEnrichment } from "./receiveColourEnrichment";

const initialState = { swatches: {} };

export const reducer = handleActions(
  {
    [RECEIVE_COLOUR_ENRICHMENT]: receiveColourEnrichment
  },
  initialState
);
